export default "__VITE_ASSET__Ce956Mnw__"